module.exports = __webpack_public_path__ + "overview-a5b6df21/500-ec94071fcac0dffa7e92bb3aad86c1f7.svg";